import { useEffect, useState } from 'react'

// Query matches thiết bị có con trỏ chính xác + hover — thực tế = có chuột =
// desktop/laptop. Tablet + mobile (touch) không match, sẽ đi tiếp luồng
// enqueue print queue (agent Windows in ra máy tại kho).
const DESKTOP_QUERY = '(hover: hover) and (pointer: fine)'

// Returns true khi user đang trên máy tính (mouse). Dùng để chọn giữa in bằng
// window.print() trên máy hiện tại vs enqueue print job đến agent.
export function useCanUseLocalPrint(): boolean {
    const [canUse, setCanUse] = useState<boolean>(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return false
        return window.matchMedia(DESKTOP_QUERY).matches
    })

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return
        const mql = window.matchMedia(DESKTOP_QUERY)
        const handler = (ev: MediaQueryListEvent) => setCanUse(ev.matches)
        mql.addEventListener('change', handler)
        return () => mql.removeEventListener('change', handler)
    }, [])

    return canUse
}
